<template>
  <Page title="SPPD - SPJ" :sidebar="true">
    <SideBar ref="sidebar" @change="UpdatePegawai" />
    <div style="padding:10px; background:white; overflow:auto">
      <v-sheet tile height="34" class="d-flex">
        <v-toolbar flat style="margin-top:-10px;">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Today
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-toolbar-title
            v-if="$refs.calendar"
            style="width:200px; text-align:center;"
          >
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="700">
        <v-calendar
          ref="calendar"
          v-model="value"
          :weekdays="weekday"
          :type="type"
          :events="events"
          :event-overlap-mode="mode"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          @change="getEvents"
          @click:more="ListPelaksana"
        ></v-calendar>
      </v-sheet>
    </div>

    <Modal
      class="modal-pelaksana-harian"
      :show.sync="showPelaksana"
      :title="selectedDate | format"
      width="500px"
      :submitText="''"
      :cancelText="'TUTUP'"
    >
      <List
        dbref="SPD.SelDetailHari"
        :dbparams="{ Date: selectedDate }"
        style="width:450px"
      >
        <template v-slot="{ row }">
          <div
            v-if="row.Ordr == 1"
            style="font-size:small; font-weight:bold; padding: 10px 0"
          >
            {{ row.NoSPT }} ({{ row.TempatTujuan }})
            <div style="font-weight: normal">
              {{ row.TglBerangkat | format }} - {{ row.TglKembali | format }}
            </div>
          </div>
          <div
            v-if="row.Ordr == 2"
            style="display:flex; width:calc(100% - 30px); font-size:small; margin-left: 10px;"
          >
            <div>
              {{ row.Nama }}
            </div>
            <v-spacer />
          </div>
        </template>
      </List>
    </Modal>
  </Page>
</template>
<script>
import SideBar from './SideBar.vue'
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    SideBar,
    VueEditor,
  },
  data: () => ({
    type: 'month',
    types: ['month', 'week', 'day', '4day'],
    mode: 'stack',
    modes: ['stack', 'column'],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
      { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
      { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
    ],
    lastSPT: '',
    value: '',
    pegawai: [],
    pegcolor: {},
    dateRange: {},
    events: [],
    showPelaksana: false,
    selectedDate: null,
    colors: [
      'blue',
      'indigo',
      'green',
      'deep-purple',
      'cyan',
      'orange',
      'grey darken-1',
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party',
    ],
  }),
  methods: {
    showDetailHeader(row) {
      let isShow = row.NoSPT != this.lastSPT
      this.lastSPT = row.NoSPT
      return isShow
    },
    setToday() {
      this.value = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    UpdatePegawai(pegawai) {
      this.pegawai = pegawai
      this.pegcolor = {}
      let i = 0
      for (let p of pegawai) {
        this.pegcolor[p.Nama] = this.colors[i]
        i++
      }
      this.getEvents(this.dateRange)
    },
    ListPelaksana(d) {
      this.selectedDate = d.date
      this.showPelaksana = true
    },
    async getEvents({ start, end }) {
      this.dateRange = { start, end }
      const events = []
      let res = await this.$api.call('SPD_SelKalendar', {
        NIPS: this.pegawai.map(p => p.NIP).join(','),
        StartDate: start.date,
        EndDate: end.date,
      })

      for (let d of res.data) {
        events.push({
          name: d.name,
          start: new Date(d.start),
          end: new Date(d.end),
          color: this.pegcolor[d.name] || this.colors[0],
          timed: false,
        })
      }
      // const min = new Date(`${start.date}T00:00:00`)
      // const max = new Date(`${end.date}T23:59:59`)
      // const days = (max.getTime() - min.getTime()) / 86400000
      // const eventCount = this.rnd(days, days + 20)

      // for (let i = 0; i < eventCount; i++) {
      //   const allDay = this.rnd(0, 3) === 0
      //   const firstTimestamp = this.rnd(min.getTime(), max.getTime())
      //   const first = new Date(firstTimestamp - (firstTimestamp % 900000))
      //   const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
      //   const second = new Date(first.getTime() + secondTimestamp)

      //   events.push({
      //     name: this.names[this.rnd(0, this.names.length - 1)],
      //     start: first,
      //     end: second,
      //     color: this.colors[this.rnd(0, this.colors.length - 1)],
      //     timed: !allDay,
      //   })
      // }

      this.events = events
    },
    getEventColor(event) {
      return event.color
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
  },
}
</script>
<style lang="scss">
.modal-pelaksana-harian {
  .v-dialog--content {
    overflow-x: hidden;
  }
}
</style>
